export const DsfNavMenuSetting = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_homepage" */ "./navMenuSetting"));